<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'StealStrickRate',
  props: {
    chartTitle: {
      type: String,
      default: '转动次数'
    },
    title: {
      type: String,
      default: '转动次数'
    },
    color: {
      type: Array,
      default: () => [0, 1]
    },
    c: {
      type: String,
      default: ''
    },
    kArr: {
      type: Array,
      default: () => ['strike_count', 'steal_count']
    },
    kTitleArr: {
      type: Array,
      default: () => ['打次数', '偷次数']
    }
  },
  data() {
    return {
      chart: {},
      option: {},
      colorArr: ['#CD5C5C', '#00BFFF', '#1E90FF', '#7B68EE', '#FF69B4', '#FF7F50', '#BA55D3']
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: [this.colorArr[this.color[0]], this.colorArr[this.color[1]], '#00BFFF'],
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 45
          }
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' + this.c// 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' + this.c // 显示数值
            }
          },
          {
            name: '',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              // show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' + this.c // 显示数值
            }
          }]
      }
    },
    refresh(data) {
      this.initChart()
      const date = []
      const strickData = []
      const stealData = []
      const shieldData = []
      for (const i in data) {
        date.push(dateStrTodate(data[i].date))
        strickData.push(data[i][this.kArr[0]])
        stealData.push(data[i][this.kArr[1]])
        if (this.kArr.length > 2) {
          shieldData.push(data[i][this.kArr[2]])
        }
      }
      this.option.title.text = this.chartTitle
      this.option.xAxis.data = date
      this.option.series[0].name = this.kTitleArr[0]
      this.option.series[0].data = strickData
      this.option.series[1].name = this.kTitleArr[1]
      this.option.series[1].data = stealData
      this.option.legend.data = [this.kTitleArr[0], this.kTitleArr[1]]
      if (shieldData.length > 0) {
        this.option.series.push({
          name: this.kTitleArr[2],
          data: shieldData,
          type: 'line',
          smooth: true,
          label: {
            // show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' + this.c // 显示数值
          }
        })
        this.option.legend.data.push(this.kTitleArr[2])
        this.option.color.push(this.colorArr[this.color[3]])
      }
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>

</style>
